import { c as _c } from "react/compiler-runtime";
import { useI18n, useFormatNumber } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import classNames from 'classnames';
import React from 'react';
import styles from './review-title.module.scss';
import { ReviewsContext } from './types';
interface ReviewTitleProps {
  reviewsContext?: ReviewsContext;
  isXsMax: boolean;
  className?: string;
}
export const ReviewTitle = t0 => {
  const $ = _c(27);
  const {
    reviewsContext,
    isXsMax,
    className
  } = t0;
  const {
    interpolate,
    ninterpolate,
    gettext
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  if (!reviewsContext) {
    return null;
  }
  let courseRating;
  let t1;
  if ($[0] !== formatNumber || $[1] !== gettext || $[2] !== interpolate || $[3] !== isXsMax || $[4] !== ninterpolate || $[5] !== reviewsContext.averageRating || $[6] !== reviewsContext.ratingDistribution) {
    const totalDistributionCount = reviewsContext.ratingDistribution.reduce(_temp, 0);
    let t2;
    if ($[9] !== formatNumber || $[10] !== gettext || $[11] !== interpolate || $[12] !== isXsMax || $[13] !== reviewsContext.averageRating) {
      const courseRatingNumber = formatNumber(reviewsContext.averageRating, {
        maximumFractionDigits: 1
      });
      t2 = isXsMax ? courseRatingNumber : interpolate(gettext("%(rating)s course rating"), {
        rating: courseRatingNumber
      }, true);
      $[9] = formatNumber;
      $[10] = gettext;
      $[11] = interpolate;
      $[12] = isXsMax;
      $[13] = reviewsContext.averageRating;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    courseRating = t2;
    t1 = ninterpolate("%(rating)s rating", "%(rating)s ratings", totalDistributionCount, {
      rating: formatNumber(totalDistributionCount, {
        notation: "compact"
      })
    });
    $[0] = formatNumber;
    $[1] = gettext;
    $[2] = interpolate;
    $[3] = isXsMax;
    $[4] = ninterpolate;
    $[5] = reviewsContext.averageRating;
    $[6] = reviewsContext.ratingDistribution;
    $[7] = courseRating;
    $[8] = t1;
  } else {
    courseRating = $[7];
    t1 = $[8];
  }
  const ratings = t1;
  let t2;
  if ($[15] !== className) {
    t2 = classNames(styles["review-title"], className);
    $[15] = className;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon glyph="rating-star" color="warning" size="medium" label={false} />;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== courseRating) {
    t4 = <span className="ud-heading-xl">{courseRating}</span>;
    $[18] = courseRating;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon glyph="bullet" color="subdued" size="xsmall" label={false} />;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== ratings) {
    t6 = <span className="ud-heading-xl">{ratings}</span>;
    $[21] = ratings;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t2 || $[24] !== t4 || $[25] !== t6) {
    t7 = <div className={t2}>{t3}{t4}{t5}{t6}</div>;
    $[23] = t2;
    $[24] = t4;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
function _temp(acc, dist) {
  return acc + dist.count;
}